import { render, staticRenderFns } from "./AddressSelector.vue?vue&type=template&id=1883d2d6&scoped=true"
import script from "./AddressSelector.vue?vue&type=script&lang=js"
export * from "./AddressSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1883d2d6",
  null
  
)

export default component.exports